module.exports = __webpack_public_path__ + "img/81000.eb4241c2.jpg";